/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React, { useState } from 'react';
import { CAMPAIGN_Group, CAMPAIGN_NAME, EMAIL_TEMPLATE, LIST_TRIGGERNAME, SCHEDULED_END_DATE, SCHEDULED_START_DATE, TOTALNPI, BRANDNAME, TRIGGERSUCCESS } from 'src/constants/constant';
import { useNavigate } from 'react-router-dom';
import type { appConfigs, TriggerListData } from '../types/types';
import moment from 'moment';
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import { ViewStrokeRounded, Image03Icon } from '@hugeicons-pro/core-stroke-rounded'
import TemplatePreview from '../TemplatePreview/TemplatePreview';
import { Divider } from '@mui/material';
import OutlineButton from '../MUICustomButton/OutlineButton';
export interface PropsType {
  savedTriggerData: TriggerListData;
}

const TriggerSummary = (savedTriggerData: PropsType): JSX.Element => {
  //@ts-ignore
  const triggerData = savedTriggerData.savedTriggerData[0];
  const formatDate = (date: string | null | undefined): string => {
    return (date != null) ? moment(date).format('MM/DD/YYYY') : '-';
  };
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const [previewContent, setPreviewContent] = useState<string>("content");
  const storedAppConfig = localStorage.getItem("appConfigs");
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
  const parsedAppConfig = storedAppConfig
    ? (JSON.parse(storedAppConfig) as appConfigs[])
    : [];

  const TemplateImagePublicURL = parsedAppConfig.find(
    (item) => item.configName === "TemplateImagePublicURL"
  )?.configValue;
  const detailsArray = [
    // @ts-ignore
    { label: LIST_TRIGGERNAME, value: triggerData?.listTriggerName },
    // @ts-ignore
    { label: CAMPAIGN_NAME, value: triggerData?.campaignName },
    // @ts-ignore
    { label: SCHEDULED_START_DATE, value: formatDate(triggerData?.startDate) },
    // @ts-ignore
    { label: SCHEDULED_END_DATE, value: formatDate(triggerData?.endDate) },
    // @ts-ignore
    { label: BRANDNAME, value: triggerData?.brandName },
    // @ts-ignore
    { label: CAMPAIGN_Group, value: triggerData?.groupName },
    // @ts-ignore
    { label: EMAIL_TEMPLATE, value: triggerData?.templateName },
    // @ts-ignore
    { label: TOTALNPI, value: triggerData?.totalNPI },
  ];
  const navigate = useNavigate();
  const handleCancel = (): void => {
    navigate('/trigger');
  };
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const userData = JSON.parse(localStorage.getItem("user") ?? "{}");
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions, @typescript-eslint/no-unsafe-member-access
  const fullname = `${userData.firstName ?? ""} ${userData.lastName ?? ""}`.trim();
  console.log(triggerData);
  return (
    <>
      <div className="bg-white w-full">
        {/* Top Section: SVG Image and Text */}
        <div className="flex justify-center items-center flex-col py-4 bg-gray-50">
          <svg
            height="70px"
            width="70px"
            version="1.1"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 32 32"
            xmlSpace="preserve"
            fill="#000000"
            className="mb-2"
          >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
              <g>
                <g id="check_x5F_alt">
                  <path
                    style={{ fill: '#38b120' }}
                    d="M16,0C7.164,0,0,7.164,0,16s7.164,16,16,16s16-7.164,16-16S24.836,0,16,0z M13.52,23.383 L6.158,16.02l2.828-2.828l4.533,4.535l9.617-9.617l2.828,2.828L13.52,23.383z"
                  ></path>
                </g>
              </g>
            </g>
          </svg>
          <p className="font-semibold text-muted text-[1.5rem] mt-2">{TRIGGERSUCCESS}</p>
        </div>

        {/* Bottom Section: Split into Left (Summary) and Right (Template Preview) */}
        <div className="flex w-full"> {/* Reduced margin and border placement */}
          {/* Left: Summary */}
          <div className="w-1/2 pr-[20px]">
            <div className="mb-[10px] w-full relative"> {/* Increased width from w-3/4 to w-[85%] */}
              <div className="bg-[#f5f5f5] text-center text-[18px] font-semibold rounded-full p-[4px] text-muted w-full">
                Summary
              </div>
            </div>


            {detailsArray.map((item, index) => (
              <div key={index} className="mb-[15px] flex items-center ">
                <span className="text-muted font-semibold w-1/2 text-[14px]">{item.label}</span>
                <span className="text-muted w-1/2 truncate">{item.value}</span> {/* Added left margin */}
              </div>
            ))}
          </div>

          {/* Right: Template Preview */}
          <div className="w-1/2 pl-[20px]">
            <div className="text-16 font-semibold text-muted mb-2">Template Preview</div>

            {/* Image + Hover Effect Container */}
            <div className="relative cursor-pointer flex justify-center items-center h-[300px] border border-[#e6ecf2] rounded-lg">
              {/* eslint-disable-next-line @typescript-eslint/strict-boolean-expressions */}
              {triggerData?.templateIdentifier && (
                <img
                  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                  src={`${TemplateImagePublicURL}Template/${triggerData.templateIdentifier}/${triggerData.templateHTMLVersion}/Template_Large.png`}
                  alt="Template Preview"
                  className="icon-hover w-full"
                  onError={(e) => {
                    (e.target as HTMLImageElement).style.display = 'none';
                    setPreviewContent('');
                  }} // Hide if image fails
                  style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }}
                />
              )
              }

              <React.Fragment>
                {previewContent === '' && (
                  <HugeiconsIcon
                    icon={Image03Icon}
                    size={50}
                    color="#6B7280"
                    className="block" // Show icon when image is not available
                  />
                )}
              </React.Fragment>

              {/* Centered Preview Icon (Only over Image) */}
              <div
                className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 opacity-0 hover:opacity-100 transition-opacity rounded-lg"
                onClick={() => setIsPreviewModalOpen(true)}
              >
                <HugeiconsIcon
                  icon={ViewStrokeRounded}
                  size={24}
                  color="white"
                  strokeWidth={0.5}
                  className="cursor-pointer"
                  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                  onClick={() => setIsPreviewModalOpen(true)}
                />
              </div>
            </div>

            {/* Created On & Username (Outside Hover Effect) */}
            <div className="text-sm text-muted mb-1 mt-2">
              <span className="font-semibold text-[14px]">Created:</span>
              <span className="font-normal text-[14px]">
                {moment(triggerData.createdOn).format('MM/DD/YYYY h:mmA')}
                <span className="italic"> ({fullname})</span>
              </span>
            </div>
          </div>

          <TemplatePreview
            isOpen={isPreviewModalOpen}
            onClose={() => setIsPreviewModalOpen(false)}
            content={triggerData?.templateContent ?? ''}
            campaignType="ListTrigger"
            campaignId={triggerData.id}
          />


        </div>
      </div>
      <div className="bg-white">
        {/* Gray Horizontal Line */}
        <Divider sx={{ color: '#D9D9D9', marginBottom: '30px', marginTop: '30px' }} />

        <div className="flex justify-end py-2 mt-2 pr-4"> {/* Aligns button to the right */}
          <OutlineButton onClick={handleCancel} type='rounded' color='red' width='180px'>
            List Trigger Overview
          </OutlineButton>
        </div>
      </div>
    </>
  );
};

export default TriggerSummary;
